import { ListPaginationMeta } from "utils/helpers/pagination";

export type ChassisHeightFilterValue = "ALL";

export type ChassisHeightYearFilter = "ALL" | "2016";

export interface ChassisHeightFilterOption {
  id: number;
  name: string;
}

export type ChassisHeightSelectOption = {
  value: string;
  labelKey?: string;
  label?: string;
};

export type ChassisHeightListMeta = ListPaginationMeta;

export type ChassisHeightFormDropDownKey = "manufacturers" | "masterModels";

export type ChassisHeightFormDropDownState = {
  items: ChassisHeightFilterOption[];
  page: number;
  perPage: number;
  meta: ChassisHeightListMeta;
  loading: boolean;
};

export type ChassisHeightFormDropDowns = Record<
  ChassisHeightFormDropDownKey,
  ChassisHeightFormDropDownState
>;

export interface ChassisHeightRow {
  manufacturerId: number;
  manufacturerName?: string;
  modelId: number;
  hangerType: string;
  weelBase: number;
  tire: string;
  height?: number;
  year?: number;
  heightIncludeBox?: number;
  superModelId?: number;
  superModelDesc?: string;
}

export interface ChassisHeightForm {
  manufacturer: string;
  masterModel: string;
  suspensionType: string;
  axleDistance: string;
  tire: string;
  year: string;
  net: string;
  chassisHeightIncludingBody: string;
}

export type ChassisHeightFormFieldKind = "string" | "number";

export const CHASSIS_HEIGHT_FORM_FIELD_KINDS: Record<
  keyof ChassisHeightForm,
  ChassisHeightFormFieldKind
> = {
  manufacturer: "number",
  masterModel: "number",
  suspensionType: "string",
  axleDistance: "number",
  tire: "string",
  year: "number",
  net: "number",
  chassisHeightIncludingBody: "number",
};

export interface ChassisHeightListResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: ChassisHeightRow[];
  meta?: ChassisHeightListMeta;
}

export interface ChassisHeightUpdatePayload {
  manufacturerId: number;
  modelId: number;
  hangerType: string;
  weelBase: number;
  tire: string;
  height: number;
  year: number;
  heightIncludeBox: number;
  superModelId: number;
}

export interface ChassisHeightDeletePayload {
  manufacturerId: number;
  modelId: number;
  hangerType: string;
  weelBase: number;
  tire: string;
}

export interface ChassisHeightDetailPayload {
  manufacturerId: number;
  modelId: number;
  hangerType: string;
  weelBase: number;
  tire: string;
}

export interface ChassisHeightUpdateResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data?: ChassisHeightRow;
}

export interface ChassisHeightDetailResponse {
  statusCode: number;
  message: string | Record<string, string>;
  data: ChassisHeightRow;
}

export interface ChassisHeightState {
  loading: boolean;
  saving: boolean;
  list: ChassisHeightRow[];
  page: number;
  perPage: number;
  meta: ChassisHeightListMeta;
  error: string | null;
  manufacturerFilter: ChassisHeightFilterValue;
  suspensionTypeFilter: ChassisHeightFilterValue;
  masterModelFilter: ChassisHeightFilterValue;
  yearFilter: ChassisHeightYearFilter;
  isAddModalOpen: boolean;
  form: ChassisHeightForm;
  formDropDowns: ChassisHeightFormDropDowns;

  detail: ChassisHeightRow | null;
  detailLoading: boolean;
  detailError: string | null;
}
